"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _getArabicMonthName = _interopRequireDefault(require("../getArabicMonthName"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
/**
 * Returns month with arabic label eg: '24 June' into '24 يونيه'
 * @param {String} month
 * @returns {String}
 */

function getArabicMonthWithLabel(month) {
  if (month) {
    var index = month.lastIndexOf(' ');
    var monthName = month.slice(index + 1);
    var arabicMonthName = (0, _getArabicMonthName["default"])(monthName);
    return month.replace(monthName, arabicMonthName);
  }
  return '';
}
var _default = exports["default"] = getArabicMonthWithLabel;